import React from "react";
import UserMenu from "./menu";

const UserBlock = ({ user }) => {
  return (
    <div className="nb-user-block">
      <div className="nb-greeting-container">
        <p className="nb-user-greetings">{`Olá, ${user.name}`}</p>
      </div>

      <UserMenu avatar={user.avatar} />
    </div>
  );
};

export default UserBlock;
